<template>
  <div class="m-box">
    <div class="login-logo">
      <img src="../../assets/images/m/newlogin_logo.png" alt="">
    </div>
    <div class="login-input">
      <el-form ref="form" :rules="rules" :model="form">
        <el-form-item class="el-form-item" prop="phone">
          <div class="phone">
            <span>+86</span>
            <el-input
              placeholder="输入手机号"
              maxlength="11"
              v-model.trim="form.phone"
              @keyup.enter.native="login('form')"
              oninput="value=value.replace(/[^\d.]/g,'')"
              clearable
            >
            </el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="phone-num">
            <el-input
              placeholder="图形验证码"
              maxlength="4"
              v-model.trim="verifyCode"
            >
            </el-input>
            <img @click="fetchCaptcha" style="cursor:pointer;height:48px" :src="captchaSrc" alt="Captcha" />
          </div>
        </el-form-item>
        <el-form-item class="el-form-item" prop="sms">
          <div class="phone-num">
            <el-input
              placeholder="输入验证码"
              maxlength="6"
              v-model.trim="form.sms"
              @keyup.enter.native="login('form')"
              clearable
              oninput="value=value.replace(/[^\d.]/g,'')"
            >
            </el-input>
            <el-button
              class="code-num"
              :disabled="getsmsFlag"
              @click="getsms('1')"
            >{{ btnsmsText }}
            </el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="agreement">
      <el-checkbox v-model="isChecked">
        我已阅读并同意
        <a href="/m/agreement/0" target="_blank">《用户服务协议》</a>
        及
        <a href="/m/agreement/1" target="_blank">《隐私政策》</a>
      </el-checkbox>
    </div>
    <div class="login-btn">
      <el-button
        type="primary"
        @click="wapLogin('form')"
        round
        :loading="btnLoading"
      >{{ submitText }}</el-button
      >
    </div>

  </div>

</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";
export default {
  name: "MLogin",
  data() {
    let checkPhone = function (rule, value, callback) {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        var reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      backUrl: this.$route.query.url ? this.$route.query.url : "",
      captchaSrc:'',
      verifyCode:'',
      uuid:'',
      btnsmsText: "获取验证码",
      timer: 60,
      form: {
        phone: localStorage.getItem("phone") || "",
        sms: "",
      },
      getsmsFlag: false,
      btnLoading: false,
      isChecked: false,
      submitText: "登录",
      loginType: 1,
      rules: {
        phone: [
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        sms: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        // username: [
        //   {
        //     required: true,
        //     message: "请输入用户名",
        //     trigger: "blur",
        //   },
        // ],
        // password: [
        //   {
        //     required: true,
        //     message: "请输入密码",
        //     trigger: "blur",
        //   },
        // ],
      },
    }
  },
  created() {
    this.fetchCaptcha()
  },
  methods: {
    ...mapActions(["MLOGIN", "GET_USERINFO"]),
    fetchCaptcha() {
      this.$api
            .codeImage({})
            .then((res) => {
              this.captchaSrc = 'data:image/png;base64,' + res.data.data.img;
              this.uuid = res.data.data.uuid;
            })
    },
    getsms(type) {
      if (this.form.phone.length !== 11) {
        this.$message({
          message: "请输入正确的手机号！",
          type: "error",
        });
        return false;
      }
      if (!this.verifyCode) {
        this.$message({
          message: "请输入图形验证码！",
          type: "error",
        });
        return false;
      }
      this.getsmsFlag = true;
      this.$api
        .sms({
          phone: this.form.phone,
          uuid:this.uuid,
          verifyCode:this.verifyCode,
          type: type,
        })
        .then((res) => {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.djs = setInterval(() => {
            if (this.timer == 0) {
              this.timer = 60;
              this.btnsmsText = "重新发送";
              this.getsmsFlag = false;
              clearInterval(this.djs);
            } else {
              this.timer--;
              this.btnsmsText = this.timer + "s重新发送";
              this.getsmsFlag = true;
            }
          }, 1000);
        })
        .catch(() => {
          this.getsmsFlag = false;
        });
    },
    wapLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.isChecked);
          if (this.isChecked) {
            this.btnLoading = true;
            this.MLOGIN({
              type: this.loginType,
              username: this.form.phone,
              password: this.form.sms,
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.btnLoading = false;
              }
              localStorage.setItem("UserToken", res.data.data.token);
              localStorage.setItem(
                "UserInfo",
                JSON.stringify(res.data.data.user)
              );
              this.goHome();
            }).catch(e=> {
              if (e.data.code === 500) {
                if (e.data.msg === "短信验证码不正确"){
                  this.btnLoading = false;
                } else {
                  this.$message.error("请重新登录！");
                  setTimeout(()=> {
                    location.reload();
                  }, 1500)
                }
              }
            })
              // .then((res) => {
              //   //请求用户信息
              //   this.GET_USERINFO()
              //     .then(() => {
              //       if (res.data.data.user.firstRegister) {
              //         this.dialogVisible = true;
              //       } else {
              //         if (this.backUrl) {
              //           this.$router.replace({ path: this.backUrl });
              //         } else {
              //           this.$router.replace({ path: "/" });
              //         }
              //       }
              //       localStorage.setItem(
              //         "phone",
              //         this.remmberMe == true ? this.form.phone : ""
              //       );
              //       localStorage.setItem(
              //         "username",
              //         this.remmberMe == true ? this.form.username : ""
              //       );
              //       localStorage.setItem(
              //         "password",
              //         this.remmberMe == true ? this.form.password : ""
              //       );
              //       localStorage.setItem('key-expire', ((new Date()).valueOf() + this.expireTime));
              //       this.btnLoading = false;
              //     })
              //     .catch(() => {
              //       this.btnLoading = false;
              //     });
              // })
              // .catch((error) => {
              //   if (error.data.code == 1003) {
              //     this.dialogVisible2 = true;
              //   }
              //   this.btnLoading = false;
              // });
          } else {
            this.$message.error("请阅读并同意大河网协议和隐私政策");
            return false;
          }
        } else {
          this.$message.error("请输入正确信息！");
          // setTimeout(()=> {
          //   location.reload();
          // }, 1500)
          return false;
        }
      });
    },
    goHome() {
      if (this.backUrl) {
        this.$router.replace({ path: this.backUrl });
      } else {
        this.$router.replace({ path: "/" });
      }
    },
  }
}
</script>

<style scoped lang="scss">
.m-box {
  position: absolute;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  background: #fff;

  .login-logo {
    img {
      width: 129px;
      // height: 81px;
      display: block;
      margin: 100px auto 35px;
    }
  }

  .login-input {
    width: 300px;
    margin: 20px auto;
    font-size: 16px;

    .phone {
      display: flex;

      span {
        display: block;
        width: 40px;
        height: 20px;
        line-height: 20px;
        border-right: 1px solid #999;
        margin-top: 15px;
      }
    }

    .el-form-item {
      border-bottom: 1px solid #ccc;
    }

    .phone-num {
      width: 100%;
      display: flex;
      height: 48px;
      border-radius: 3px;
      //   margin-top: 16px;
      .el-input {
        margin-top: 0;
        width: 240px;
      }

      .code-num {
        width: 100px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        text-align: center;
        border: none;
        padding: 0;
        background: transparent;
      }
    }

    .el-input {
      height: 48px;

      /deep/ .el-input__inner {
        height: 48px;
        border-radius: 3px;
        border: none;
        font-size: 16px;
      }

      .el-input__suffix {
        height: 100%;
      }
    }
  }

  .agreement {
    text-align: center;
    margin-top: 30px;
    /deep/ .el-checkbox__label {
      font-size: 12px;
      padding-left: 6px;
    }
    .el-checkbox {
      border-color: #666;
    }

    /deep/ .el-checkbox__inner {
      border-color: #666;
    }

    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border-color: #666;
    }
    /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
      color: #666;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: #409EFF;
    }
    a {
      color: #409EFF;
    }
  }
  .login-btn {
    width: 300px;
    height: 50px;
    margin: 35px auto;
    .el-button {
      width: 100%;
      height: 100%;
      // background: #D20202;
      background: #409EFF;
      border-radius: 25px;
      font-size: 18px;
      color: #ffffff;
      border-color: #409EFF;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/m/Login.vue